import { useTranslation } from "react-i18next";
import { formatTimeSaved } from "@/utils/time.utils";

interface Props {
  totalTimeSavedMinutes: number;
  className?: string;
}

export function TimeSavedCard({
  totalTimeSavedMinutes,
  className = "",
}: Props) {
  const { t } = useTranslation(["common"]);
  if (totalTimeSavedMinutes <= 0) return null;

  return (
    <div
      className={`flex items-center gap-2 bg-white p-2 rounded-xxs ${className}`}
    >
      <img
        src="/icons/interface-icons/shared/icon-3d-clock-up.png"
        alt={t("common:chrome.time_saved")}
        draggable={false}
        className="size-9 object-contain shrink-0"
      />
      <div className="flex-1 min-w-0">
        <p className="text-[11px] text-gray-400 font-medium tracking-wide">
          {t("common:chrome.ai_time_saved")}
        </p>
        <p className="text-sm font-bold text-black tabular-nums">
          {formatTimeSaved(totalTimeSavedMinutes)}
          <span className="text-xs font-normal text-gray-400 ms-1">
            {t("common:chrome.this_period")}
          </span>
        </p>
      </div>
    </div>
  );
}
